import React from 'react';
import { IconProps } from '.';

const SvgColoredFashionIncreasing = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#FFC2E1'
        fillRule='evenodd'
        d='M7.95 2H8.02c.384 0 .696.311.696.695 0 .395.17.687.468.902.316.227.8.38 1.4.38.598 0 1.083-.153 1.399-.38.297-.215.468-.507.468-.902 0-.384.311-.695.695-.695H13.219c.61 0 1.246 0 1.891.197.687.21 1.325.62 2.028 1.337.804.819 1.418 2.231 1.86 3.553a25.61 25.61 0 0 1 .914 3.637.683.683 0 0 1-.398.738l-2.444 1.08a1 1 0 0 0-.596.914V18a1 1 0 0 1-1 1h-9.78a1 1 0 0 1-1-1v-4.544a1 1 0 0 0-.596-.915l-2.444-1.08a.684.684 0 0 1-.398-.737c.149-.89.462-2.283.915-3.637.441-1.322 1.055-2.734 1.859-3.553.703-.717 1.342-1.127 2.028-1.337C6.703 2 7.34 2 7.95 2Z'
        clipRule='evenodd'
      />
      <path
        fill='#FF97CC'
        d='M16.81 12.47c0 .144-.072.275-.158.392a.907.907 0 0 0-.069.109c-.078.144-.216.265-.384.265a.342.342 0 0 1-.348-.337V9.65c0-.256.215-.463.48-.463.264 0 .478.207.478.463v2.822ZM4.97 13.236c-.169 0-.307-.12-.385-.265a.923.923 0 0 0-.07-.11c-.085-.116-.156-.247-.156-.39V9.649c0-.256.214-.463.479-.463.264 0 .479.207.479.463v3.25a.342.342 0 0 1-.348.337Z'
      />
      <path
        fill='#F05046'
        d='M22.965 17.937a.75.75 0 0 1-1.498.081l-.12-2.23-3.671 4.78a.75.75 0 0 1-1.094.103l-3.317-2.96-3.538 4.722a.75.75 0 0 1-1.2-.9l4.028-5.376a.75.75 0 0 1 1.1-.11l3.323 2.968 3.266-4.254-2.27.123a.75.75 0 0 1-.081-1.497l4.062-.22a.75.75 0 0 1 .79.708l.22 4.062Z'
      />
    </svg>
  );
};

export default SvgColoredFashionIncreasing;
